export default __webpack_public_path__ + "static/media/icono-abstracto.3fd2a81b.svg";